module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('ul', {
    staticClass: "detail list"
  }, [_c('li', [_c('p', [_vm._v("Gebruikersnaam")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.gebruikersnaam))])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Wachtwoord")]), _vm._v(" "), _c('p', [_vm._v("****** "), _c('a', {
    staticClass: "edit",
    attrs: {
      "href": _vm.ctx + '/login-ingelogd/ww-wijzigen.html'
    }
  }, [_vm._v("wijzig "), _c('span', {
    staticClass: "icon clean"
  }, [_vm._v(">")])])])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Relatienummer")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.relatienummer))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h3', [_c('span', [_vm._v("Accountgegevens")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dacaa5e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/components/mijngegevens/accountgegevens.vue
// module id = 32
// module chunks = 0